// AUTO-GENERATED from .env files
// Prefix: CLIENT_
export const environment = {
    "serverApiUrl": "https://aboneo-api-recette.cerema.dev/api",
    "orionUrl": "https://orion-recette.cerema.fr/auth/realms/CeremaApps",
    "clientId": "aboneo_recette",
    "redirectUri": "https://aboneo-recette.cerema.dev",
    "deconnexionUri": "https://aboneo-recette.cerema.dev/login",
    "homePath": "/",
    "redirectPage": "/dashboard",
    "runtime": true
};
